<template>
  <Modal v-model:is-open="isOpen" class="cancel-order-modal">
    <Button
      class="flex self-end"
      prefix_icon="ic-x"
      :c_style="{ type: 'tertiary', style: 'B' }"
      @click="handleClose"
    />

    <div class="flex flex-col items-center gap-10 font-secondary font-medium">
      <h1 class="text-size_6 font-bold">
        {{ $t("user.orders.actions.cancel") }} #{{ orderId }}
      </h1>

      <p class="text-size_5 font-medium text-neutral-800">
        {{ $t("user.orders.messages.cancel_order") }}
      </p>
    </div>

    <div class="flex flex-col gap-5">
      <Button
        class="w-full"
        :c_style="{ name: 'danger', type: 'outline' }"
        :label="$t('user.orders.actions.cancel')"
        :loading
        :test-id="TEST_IDS.CONFIRM_CANCEL_ORDER_BUTTON"
        @click="$emit('cancelOrder')"
      />

      <Button
        class="w-full"
        :label="$t('user.orders.actions.keep')"
        @click="$emit('close')"
      />
    </div>
  </Modal>
</template>

<script setup lang="ts">
import Button from "~/components/common/Atom/Button.vue";
import Modal from "~/components/common/Atom/Modal.vue";
import TEST_IDS from "~~/tests/constants/ids";
const isOpen = defineModel("isOpen", { default: false });

const emit = defineEmits<{
  close: [];
  cancelOrder: [];
}>();

defineProps<{
  orderId: string;
  loading?: boolean;
}>();

const handleClose = () => {
  isOpen.value = false;
  emit("close");
};
</script>

<style>
.cancel-order-modal {
  .modal-content {
    @apply flex flex-col gap-10 pb-14 pt-7;
  }
}
</style>
